import React, { useCallback, useState } from 'react';

import { LayerId } from 'yeself-common/typings/guide/LayerCommon';

import SelectField from '../../components/SelectField';

import {
    CompletedRelatedGuideRuleValues,
    FinishedRelatedGuideRuleValues,
    SeenRelatedGuideRuleValues,
    HasNotSeenRelatedGuideRuleValues,
} from '../types';

type RelatedGuideRuleFieldProps = {
    value:
        | SeenRelatedGuideRuleValues
        | CompletedRelatedGuideRuleValues
        | FinishedRelatedGuideRuleValues
        | HasNotSeenRelatedGuideRuleValues;
    onChange: (
        value:
            | SeenRelatedGuideRuleValues
            | CompletedRelatedGuideRuleValues
            | FinishedRelatedGuideRuleValues
            | HasNotSeenRelatedGuideRuleValues
    ) => void;
    options: { value: LayerId; label: string }[];
};

const RelatedGuideRuleField = ({
    value,
    onChange,
    options = [],
}: RelatedGuideRuleFieldProps): React.ReactElement => {
    const [levelValue, setLevelValue] = useState({
        level0: value.level?.[0]?.data.value.value || null,
    });

    const handleOnChange = useCallback(
        (index: number) => (newValue) => {
            const newLevelValue = { ...levelValue, [`level${index}`]: newValue };

            const level: RelatedGuideRuleFieldProps['value']['level'] = [
                newLevelValue.level0
                    ? { data: { value: { value: newLevelValue.level0, label: '' } } }
                    : undefined,
            ];

            setLevelValue(newLevelValue);
            onChange({ ...value, level });
        },
        [levelValue, onChange, value]
    );

    return (
        <SelectField
            autoWidth
            options={options}
            value={levelValue.level0 || ''}
            onChange={handleOnChange(0)}
        />
    );
};

export default RelatedGuideRuleField;
